import { useState } from "react";

export function GiveUp({ busy, onGiveUp }: { busy: boolean; onGiveUp: () => void }) {
  const [confirm, setConfirm] = useState(false);
  if (confirm) {
    return (
      <button
        type="button"
        disabled={busy}
        onClick={() => {
          setConfirm(false);
          onGiveUp();
        }}
        className="flex-1 rounded-xl bg-cold/80 py-3 text-sm font-semibold text-white active:opacity-70"
      >
        точно здатись?
      </button>
    );
  }
  return (
    <button
      type="button"
      disabled={busy}
      onClick={() => {
        setConfirm(true);
        window.setTimeout(() => setConfirm(false), 3000);
      }}
      className="flex-1 rounded-xl bg-[rgba(128,128,128,0.18)] py-3 text-sm font-semibold active:opacity-70 disabled:opacity-40"
    >
      🏳 здатись
    </button>
  );
}
